export default {
  GeoItemSearchComment: require('./GeoItemSearchComment').default,
};
